<template>
  <div>
    <div class="record1"></div>
    <div class="record2">
      <el-form ref="added" inline size="medium">
        <el-form-item label="名称">
          <el-input @keyup.enter.native="search" v-model="query.name" placeholder="请输入名称"
            clearable show-word-limit></el-input>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'recruit/query')">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'recruit/increase')">
          <el-button icon="el-icon-circle-plus-outline" @click="reset('')"> 新增 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="record3">
      <el-table v-loading='loading' stripe border :data="list" tooltip-effect="dark" style="width: 98%">
        <el-table-column align='center' prop="name" label="招聘名称"></el-table-column>
        <el-table-column align='center' prop="company_name" label="招聘企业"></el-table-column>
        <el-table-column align='center' prop="created_user" label="创建人"></el-table-column>
        <el-table-column align='center' prop="created_at" label="创建时间" width="180"></el-table-column>
        <el-table-column align='center' label="投递人数" width="130">
          <template slot-scope="scope">
            <el-link type="primary" style="text-decoration: underline;font-size: 15px;" :underline='false' @click="$router.push({ 
              path: '/applicants',
              query: {
                row: JSON.stringify(scope.row)
              }
            })" v-if="scope.row.recruitment_delivery.length">{{ scope.row.recruitment_delivery.length }}</el-link>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column align='center' label="报名状态" width="130">
          <template slot-scope="scope">
            <span style="color: #ffac1c;" v-if="scope.row.audit_status == 10">{{ scope.row.audit_status_description }}</span>
            <span style="color: #0dcd2e;" v-if="scope.row.audit_status == 20">{{ scope.row.audit_status_description }}</span>
            <span v-if="scope.row.audit_status == 30" style="color: #fa1c1c;">未通过
              <el-popover
                placement="top-start"
                title="未通过原因"
                width="200"
                trigger="hover"
                :content="scope.row.reject_reason">
                <i class="el-icon-question" slot="reference" style="font-size: 16px;cursor: pointer;" v-if="scope.row.reject_reason"></i>
              </el-popover>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align='center' width="300">
          <template slot-scope="scope">
            <el-button v-if="JudgeButton(role_permission,'recruit/edit') && scope.row.is_internal == 1" size="mini" type="primary"
              @click="reset(scope.row.id)">编辑</el-button>
            <el-button v-if="JudgeButton(role_permission,'recruit/edit') && scope.row.is_internal == 0 && scope.row.audit_status != 20 && scope.row.audit_status != 30" size="mini" type="warning"
              @click="$refs.verify.show(scope.row)">审核</el-button>
            <el-button v-if="JudgeButton(role_permission,'recruit/query')" size="mini" type="primary"
              @click="$refs.detail.show(scope.row.id)">查看</el-button>
            <el-button v-if="JudgeButton(role_permission,'recruit/delete')" size="mini"
               type="danger" @click="handleDelete(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
        :total="query.total">
      </el-pagination>
    </div>
    <verifyDialog ref='verify' @success='getList()'></verifyDialog>
    <detailDialog ref='detail' />
  </div>
</template>
<script>
  import userInfoAPI from '@/api/api';
  var that;
  import verifyDialog from './components/verifyDialog.vue'
  import detailDialog from './components/detailDialog.vue'
  export default {
    components:{
      verifyDialog,
      detailDialog
    },
    props: {},
    data() {
      return {
        loading: true,
        query: {
          page_limit: 10,
          page: 1,
          name: '',
          type: '',
          enroll_status: '',
          total: 0
        },
        list: []
      }
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    watch: {},
    created() {
      that = this;
      if (this.$store.state.cache.cacheRecruitQuery) this.query = this.$store.state.cache.cacheRecruitQuery
      this.getList()
    },
    beforeDestroy() {
      this.$store.commit('CACHE_RECRUIT', this.query)
    },
    methods: {
      handleChange(e) {
        if (e[0]) {
          this.query.area_code = e[0]
          this.query.village_code = e[1] || ''
          if(e[1]){
            that.$refs.area.dropDownVisible = false
          }
        } else {
          this.query.area_code = ''
          this.query.village_code = ''
        }
      },
      handleCategoryChange(e) {
        if (e[0]) {
          this.query.service_category_id = e[0]
          this.query.service_project_id = e[1] || ''
          if(e[1]){
            that.$refs.pro.dropDownVisible = false
          }
        } else {
          this.query.service_category_id = ''
          this.query.service_project_id = ''
        }
      },
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      submitForm() {
        this.$refs['added'].validate(valid => {
          if (!valid) return
          // TODO 提交表单
        })
      },
      handleExport() {
        this.query.flag = 'export';
        this.getList();
      },
      search() {
        this.loading = true;
        this.query.page = 1;
        this.list = [];
        this.getList()
      },
      handleDelete(row) { //删除
        this.$confirm('此操作将永久删除该记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.delRecruit(row.id).then(res => {
            if (res.data.code == 0) {
              this.$message.success(res.data.msg)
              this.getList()
            }
          })
        })
      },
      reset(id) { //详情
        this.$router.push({
          path: '/recruitAdd',
          query: {
            id: id,
          }
        })
      },
      getList() {
        this.loading = true
        userInfoAPI.getRecruitIdList(this.query).then(res => {
          if (res && res.data.code == 0) {
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.getList();
      }
    }
  }
</script>
<style lang="scss" scoped>
  .record1 {
    height: 20px;
  }

  .record3 {
    margin-left: 20px;
  }

  .record2 .el-form-item {
    margin-left: 20px;
  }
</style>
